import { Link } from 'react-router-dom'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { ColumnItem } from '../../../components/common'
import { Label, StyledLabel } from '../../../components/label'
import type { LabelProps } from '../../../components/label'
import { StyledProductCard } from '../../../components/card/ProductCard'
import { Text } from '../../../components/text'

import 'react-lazy-load-image-component/src/effects/blur.css'

export const ProductCard = ({ id, balance, product, status, statusLabel }: components['schemas']['UserProductDto']) => {
  const colorFromStatus: () => Pick<LabelProps, 'backgroundColor' | 'textColor'> = () => {
    switch (status) {
      case 'SALE':
        return { backgroundColor: 'primary_2', textColor: 'primary_5' }
      case 'SALE_COMPLETED':
        return { backgroundColor: 'primary_5', textColor: 'text_white' }
      case 'SELL':
        return { backgroundColor: 'gray_8', textColor: 'text_white' }
      case 'TO_BE_SETTLEMENT':
        return { backgroundColor: 'error_light', textColor: 'error' }
      case 'SETTLEMENT_FINISH':
        return { backgroundColor: 'gray_2', textColor: 'text_secondary' }
      default:
        return { backgroundColor: 'gray_6', textColor: 'text_white' }
    }
  }

  const { backgroundColor, textColor } = colorFromStatus()

  return (
    <Link to={`/myPage/asset/${id}?redirectUrl=${window.location.pathname}`}>
      <ColumnItem $gap={8}>
        <Container radius={8} isShadow={true}>
          <Label size="medium" shape="semiRound" backgroundColor={backgroundColor} textColor={textColor}>
            {statusLabel}
          </Label>
          <img
            src={product?.imageUri}
            alt={product?.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Container>
        <ColumnItem $gap={4}>
          <Text size={12} color="text_secondary">
            {product?.artist}
          </Text>
          <Text size={16} weight={500} lineHeight={24} $textOverflow="ellipsis">
            {product?.name}
          </Text>
          <Text size={18} weight={600} block={true}>
            {balance.toLocaleString()}원
          </Text>
        </ColumnItem>
      </ColumnItem>
    </Link>
  )
}

const Container = styled(StyledProductCard)`
  display: flex;
  z-index: 1;
  img {
    position: absolute;
    z-index: -1;
  }
  ${StyledLabel} {
    position: absolute;
    top: 0;
    left: 0;
  }
`
